import "./cover.css";
import Cover1 from "../../assets/Cover1.png";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

const Cover = () => {
  const isMobile = useMediaQuery({ maxWidth: 1250 });
  const [count, setCount] = useState(0);
  const NumeroFinal = 20000;
  const duracion = 1500;

  useEffect(() => {
    const intervalTime = 20;
    const increment = NumeroFinal / (duracion / intervalTime);

    const interval = setInterval(() => {
      setCount((prev) => {
        const nextValue = prev + increment;
        return nextValue >= NumeroFinal ? NumeroFinal : nextValue;
      });
    }, intervalTime);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {isMobile ? (
        <>
          <div className="cover-mobile">
            <div className="cover-content-mobile">
              <img src={Cover1} alt="cover" className="cover-img-mobile" />
              <div className="text-cover">
              <p className="title-mobile">Cobertura amplia</p>
                <p className="text">
                  Presencia estratégica en múltiples localidades Argentinas.
                </p>
                <p className="text">Centros de distribución propios.</p>
                <p className="text">
                  Flota de vehículos que aseguran la eficiencia logística.
                </p>
              </div>
              <div className="counter-mobile">
                <p className="number-mobile">
                  +{Math.floor(count).toLocaleString("es-ES")}
                </p>
                <p className="text-counter-mobile">puntos de atención por mes</p>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="cover">
            <div className="cover-content-l">
              <img src={Cover1} alt="cover" className="cover-img" />
            </div>
            <div className="cover-content-r">
              <div className="content-cover">
                <p className="text-cover title-cover">Cobertura amplia.</p>
                <p className="text-cover">
                  Presencia estratégica en múltiples localidades Argentinas.
                </p>
                <p className="text-cover">Centros de distribución propios.</p>
                <p className="text-cover">
                  Flota de vehículos que aseguran la eficiencia logística.
                </p>
              </div>
              <div className="cover-counter">
                <p className="number-counter">
                  +{Math.floor(count).toLocaleString("es-ES")}
                </p>
                <p className="text-counter">puntos de atención por mes</p>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default Cover;
